import React, { createContext, useState, useEffect } from 'react';

// Cria o contexto para o tema
export const ThemeContext = createContext();

// Provedor do contexto que vai envolver a aplicação
export const ThemeProvider = ({ children }) => {
  // Converte o valor de localStorage para booleano ou usa false como padrão
  const [isDarkMode, setIsDarkMode] = useState(
    JSON.parse(localStorage.getItem('darkMode')) || false
  );

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [isDarkMode]);
  
  useEffect(() => {
    // Atualiza o valor no localStorage sempre que isDarkMode mudar
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};
